var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTableCellsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 47h60v1H0zm18-35h24v24H18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 26a2 2 0 110-4 2 2 0 010 4zm0 7a2 2 0 110-4 2 2 0 010 4zm0-14a2 2 0 110-4 2 2 0 010 4z",
    fillOpacity: 0.16,
    fill: "#003A5D"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA2MCA0OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGwtcnVsZT0ibm9uemVybyIgZmlsbD0ibm9uZSI+CiAgICAgICAgPHBhdGggZD0iTTAgMGg2MHY0OEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0wIDQ3aDYwdjFIMHpNMTggMTJoMjR2MjRIMTh6Ii8+CiAgICAgICAgPHBhdGggZD0iTTMwIDI2YTIgMiAwIDEgMSAwLTQgMiAyIDAgMCAxIDAgNHptMCA3YTIgMiAwIDEgMSAwLTQgMiAyIDAgMCAxIDAgNHptMC0xNGEyIDIgMCAxIDEgMC00IDIgMiAwIDAgMSAwIDR6IiBmaWxsLW9wYWNpdHk9Ii4xNiIgZmlsbD0iIzAwM0E1RCIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgTableCellsIcon as ReactComponent };